/* eslint-disable no-unused-expressions */
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import React, { useRef, useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Box, Button, TextField, Fade } from "@mui/material";
import { Dialog, DialogTitle } from "@mui/material";
import { DialogActions, Typography, Skeleton } from "@mui/material";

// component
import FormService from "Lib/API/Forms";
import { Fonts, FontWeights } from "theme/fontConfig";

// ─── LOCAL TESTING ONLY: bypass OTP verification ─────────────────────────────
// Set REACT_APP_BYPASS_OTP_MOCK=true in .env.local to enable.
// This variable is intentionally absent from .env.production so it can never leak.
const DEV_MOCK_RESULT = process.env.REACT_APP_BYPASS_OTP_MOCK === "true" ? {
  "tokenForOneHour": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb250YWN0SWQiOiI2OTYzYTZlNzg2MGIwYjAwMjQzOTZlNDEiLCJmb3JtSWQiOiI2OWU0ZTRmYmZlY2Y1YzAwMjZmNTI1OGYiLCJpYXQiOjE3NzY2MDg1ODIsImV4cCI6MTc3NjYxMjE4Mn0.VWFgcjSr6oU9iVcHLgkCkOqGYFdYvLEmvjvHnWRiyNA",
  "formInfo": {"ledgerForCalculation":{"dateRange":{"from":"2019-12-31T22:00:00.000Z","to":"2026-12-12T22:00:00.000Z"},"ledger":{"id":"655a0b1f87265f002fb3e32b","name":"Membership"},"fallbackAmount":2000},"participantsDetails":{"total":0},"showLastYear":false,"alwaysAvailable":true,"totalAccounts":1,"totalPaid":0,"validateContacts":false,"validateFamily":false,"enableHouseHold":false,"formTags":["ggg","Ski","WWw"],"applyForFinancialAid":false,"archived":false,"active":true,"_id":"69e4e4fbfecf5c0026f5258f","formEndDate":null,"formName":"Combined","formStartDate":"2026-04-19T00:00:00.000Z","membershipPriceType":"dynamic","membershipPricing":[{"installmentDetailsTransaction":{"numberOfInstallment":0,"lastInstallmentDate":null},"isInstallmentTransaction":false,"_id":"69e4e4fbfecf5c0026f52590","title":"Standard Membership","openAmount":false,"chargeDate":"2026-04-19T00:00:00.000Z","dueDate":"2026-04-19T00:00:00.000Z","isRecurring":false,"tax_deductible":100,"tax_type":"%","ledger":{"id":"655a0b1f87265f002fb3e32b","name":"Membership"},"order":1,"addAmount":500,"amountType":"$"},{"installmentDetailsTransaction":{"numberOfInstallment":0,"lastInstallmentDate":null},"isInstallmentTransaction":false,"_id":"69e4e4fbfecf5c0026f52591","title":"Gold","openAmount":false,"chargeDate":"2026-04-19T00:00:00.000Z","dueDate":"2026-04-19T00:00:00.000Z","isRecurring":false,"tax_deductible":100,"tax_type":"%","ledger":{"id":"655a0b1f87265f002fb3e32b","name":"Membership"},"order":2,"addAmount":12345,"amountType":"$","type":"static"},{"installmentDetailsTransaction":{"numberOfInstallment":0,"lastInstallmentDate":null},"isInstallmentTransaction":false,"_id":"69e4e4fbfecf5c0026f52592","title":"Platinum","openAmount":true,"chargeDate":"2026-04-19T00:00:00.000Z","dueDate":"2026-04-19T00:00:00.000Z","isRecurring":false,"tax_deductible":100,"tax_type":"%","ledger":{"id":"655a0b1f87265f002fb3e32b","name":"Membership"},"order":3,"addAmount":10,"amountType":"$"}],"addOns":[{"installmentDetailsTransaction":{"numberOfInstallment":0,"lastInstallmentDate":null},"isInstallmentTransaction":false,"_id":"69e501d9fecf5c0026f52753","title":"Parking","amount":120,"openAmount":false,"chargeDate":"2026-04-19T00:00:00.000Z","dueDate":"2026-04-19T00:00:00.000Z","tax_deductible":0,"tax_type":"%","ledger":{"id":"6565b5c1f4e4f4002f6a14d6","name":"Transaction Ledger"},"order":1,"isRequired":false},{"installmentDetailsTransaction":{"numberOfInstallment":0,"lastInstallmentDate":null},"isInstallmentTransaction":false,"_id":"69e501d9fecf5c0026f52754","title":"Security","amount":240,"openAmount":false,"chargeDate":"2026-04-19T00:00:00.000Z","dueDate":"2026-04-19T00:00:00.000Z","tax_deductible":100,"tax_type":"%","ledger":{"id":"675a9ecb1f9ccc002f2d9521","name":"Main ledger"},"order":2,"isRequired":true},{"installmentDetailsTransaction":{"numberOfInstallment":0,"lastInstallmentDate":null},"isInstallmentTransaction":false,"_id":"69e501d9fecf5c0026f52755","title":"Donation","amount":0,"openAmount":true,"chargeDate":"2026-04-19T00:00:00.000Z","dueDate":"2026-04-19T00:00:00.000Z","tax_deductible":0,"tax_type":"%","ledger":{"id":"6565b5c1f4e4f4002f6a14d6","name":"Transaction Ledger"},"order":3,"isRequired":false}],"created_by":"615ff5c63ba59207b879d492","organization":"615ff5c63ba59207b879d492","createdAt":"2026-04-19T14:21:47.641Z","updatedAt":"2026-04-19T14:22:05.290Z","__v":0,"lastYearTotalPaid":6542.78,"lastYearForCalculation":6542.78},
  "accountInfo": {"payment":{"startFrom":"2026-04-16T14:09:50.672Z","paid":false,"account_type":"member","balance":10847.5,"wallet":"69595e312932cd002fdf5eab","account_sub_type":{"id":"62bb0184417a5a0030c73dc4","title":"husam "},"billing_type":{"id":"64ae7936728c72002e4283dc","title":"Hijazi 2"}},"profile_img":"","appear_in_member_directory":false,"deceases":["6538e595601f2a001d218868","6538e595601f2a001d218868"],"family_members":[{"location":"","account_permission":"","relationship":[],"profile_img":"8eba484f-edca-4598-a576-a824d5b91b8b_emailEasy 2.png","archived":false,"mark_as_deceased":false,"tags":["husam","Jwan","Ran"],"is_admin_user":true,"nickname":"","haveMemberPortalAccount":true,"unsubscribedEmail":false,"unsubscribedText":false,"_id":"6538e554601f2a001d218813","first_name":"Ran","last_name":"Shochat","full_name":"Ran Shochat","organization":"615ff5c63ba59207b879d492","account_id":"6538e554601f2a001d218811","account":"6538e554601f2a001d218811","createdAt":"2023-10-25T09:52:20.749Z","updatedAt":"2026-04-19T12:14:52.859Z","account_type":"member","__v":0,"member_id":2366,"email_address":"ran+devmember@easyshul.com","mobile_number":"+15612558555"},{"account_permission":"family_member","relationship":[],"profile_img":"","archived":false,"mark_as_deceased":false,"tags":[],"is_admin_user":false,"nickname":"","haveMemberPortalAccount":false,"_id":"688f115aa3bcf700256025dc","first_name":"Mattan","last_name":"Shochat","full_name":"Mattan Shochat","account_id":"6538e554601f2a001d218811","account":"6538e554601f2a001d218811","organization":"615ff5c63ba59207b879d492","account_type":"member","member_id":4212},{"account_permission":"family_member","relationship":[],"profile_img":"","archived":false,"mark_as_deceased":false,"tags":[],"is_admin_user":false,"nickname":null,"haveMemberPortalAccount":false,"_id":"688f1164a3bcf700256025fe","first_name":"Alon","last_name":"Shochat","full_name":"Alon Shochat","account_id":"6538e554601f2a001d218811","account":"6538e554601f2a001d218811","organization":"615ff5c63ba59207b879d492","account_type":"member","member_id":4213},{"account_permission":"family_member","relationship":[],"profile_img":"","archived":false,"mark_as_deceased":false,"tags":[],"is_admin_user":false,"nickname":null,"haveMemberPortalAccount":false,"_id":"688f1170a3bcf70025602620","first_name":"Aviv","last_name":"Shochat","full_name":"Aviv Shochat","account_id":"6538e554601f2a001d218811","account":"6538e554601f2a001d218811","organization":"615ff5c63ba59207b879d492","account_type":"member","member_id":4214},{"account_permission":"family_member","relationship":[],"profile_img":"","archived":false,"mark_as_deceased":false,"tags":[],"is_admin_user":false,"nickname":null,"haveMemberPortalAccount":false,"_id":"688f1330f96f050026bad15a","first_name":"Mira","last_name":"Shochat","full_name":"Mira Shochat","organization":"615ff5c63ba59207b879d492","account_id":"6538e554601f2a001d218811","account":"6538e554601f2a001d218811","account_type":"member","member_id":4215},{"account_permission":"family_member","relationship":[],"profile_img":"","archived":false,"mark_as_deceased":false,"tags":[],"is_admin_user":false,"nickname":null,"haveMemberPortalAccount":false,"_id":"688f1330f96f050026bad15c","first_name":"Dana","last_name":"Shochat","full_name":"Dana Shochat","organization":"615ff5c63ba59207b879d492","account_id":"6538e554601f2a001d218811","account":"6538e554601f2a001d218811","account_type":"member","member_id":4216}],"archived":false,"status":"STATUS1","_id":"6538e554601f2a001d218811","family_name":"Ran Shochat Family","organization":"615ff5c63ba59207b879d492","admin_name":"Ran Shochat","addresses":[{"location":{"formattedAddress":"3355 Blue Fin Drive","place_id":"ChIJpWlWrHkp2YgRkShroipMNeA"},"active":true,"billing":false,"applyAddressToContacts":false,"_id":"69c401259246770025a2259a","city":"West Palm Beach","state":"FL","zip_code":"33411","country":"US"},{"location":{"formattedAddress":"2071 Chagall Circle","place_id":"ChIJ08hLgv8p2YgR3UDmgOL7-B4"},"active":false,"billing":true,"applyAddressToContacts":false,"_id":"69c401259246770025a2259b","city":"West Palm Beach","state":"FL","zip_code":"33409","country":"US"}],"createdAt":"2023-10-25T09:52:20.707Z","updatedAt":"2026-03-30T11:13:02.927Z","__v":0,"main_contact":{"_id":"6538e554601f2a001d218813","first_name":"Ran","last_name":"Shochat","full_name":"Ran Shochat","email_address":"ran+devmember@easyshul.com","mobile_number":"+15612558555"},"account_id":1328,"mailLabelName":"Ran Shochat","first_name":"Ran","last_name":"Shochat","primary_email_address":"ran+devmember@easyshul.com"},
  "listCards": {"data":[{"id":"card_1SrC30K8MRVxnyu4Y8Ch9chI","object":"card","brand":"MasterCard","country":"US","customer":"cus_TYu3hiOVwG20uK","exp_month":12,"exp_year":2029,"last4":"4444","funding":"credit","is_default":true}]},
  "listAch": {"data":[{"accountNumber":"XXXX6789","accountType":"individual","nameOnAccount":"asdfasdf sdfgsafg","routingNumber":"110000000","id":"ba_1SoIPfK8MRVxnyu48S4FpAkR","status":"new"}]}
} : null;
// ─────────────────────────────────────────────────────────────────────────────

const OtpSchema = Yup.object().shape({
  otp: Yup.array()
    .of(
      Yup.string()
        .matches(/^[0-9]$/, "Must be a digit")
        .required("Required")
    )
    .min(6, "Enter 6 digits"),
});

const OtpModal = ({
  open,
  handleClose,
  setVerifyModal,
  onHandleSubmit,
  tempToken,
}) => {
  const inputRefs = useRef([]);
  const { id } = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const contactId = query.get("contactId");
  // state
  const [coolDown, setCoolDown] = useState(0);
  const [otpToken, setOtpToken] = useState(null);
  const [email, setEmail] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const [resendCount, setResendCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleChange = (e, index, setFieldValue) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setFieldValue(`otp[${index}]`, value);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index, values, setFieldValue) => {
    if (e.key === "Backspace") {
      if (values.otp[index]) {
        setFieldValue(`otp[${index}]`, "");
      } else if (index > 0) {
        inputRefs.current[index - 1]?.focus();
        setFieldValue(`otp[${index - 1}]`, "");
      }
    }
  };

  const requestOtp = async () => {
    const body = {
      contactId: contactId,
      formId: id,
    };
    setIsLoading(true);
    try {
      const res = await FormService.sentCode(tempToken?.token, body);
      setOtpToken(res?.result?.token);
      setEmail(res?.result?.email);
    } catch (error) {
      setErrorMessage(error?.data?.message);
      setTimeout(() => {
        setErrorMessage(null);
      }, 7000);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (coolDown > 0) {
      const timer = setInterval(() => {
        setCoolDown((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [coolDown]);

  // LOCAL BYPASS: auto-skip OTP on first mount, never render the Dialog
  useEffect(() => {
    if (DEV_MOCK_RESULT) {
      setVerifyModal(false);
      onHandleSubmit(DEV_MOCK_RESULT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Send OTP when modal opens
  useEffect(() => {
    if (open && tempToken?.token && !DEV_MOCK_RESULT) {
      requestOtp();
      setResendCount(0);
      setCoolDown(30); // first resend after 30s
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, tempToken]);

  const handleResend = () => {
    requestOtp();
    setResendCount((prev) => prev + 1);
    if (resendCount === 0) {
      setCoolDown(60); // after first, wait 1min
    } else {
      setCoolDown(60);
    }
  };

  // In bypass mode, render nothing — no Dialog, no backdrop, no blocking
  if (DEV_MOCK_RESULT) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      className="otp-dialog"
      fullWidth
      TransitionComponent={Fade}
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
          boxShadow: 10,
        },
      }}
    >
      <DialogTitle>
        <Typography
          variant="h6"
          fontWeight="bold"
          align="center"
          sx={{ fontSize: Fonts.GeneralHeaderFont.fontSize }}
        >
          Verify
        </Typography>
      </DialogTitle>

      <Box
        sx={{
          p: {
            xs: 0,
            sm: 0,
            md: 2,
          },
        }}
      >
        <Typography variant="body2" align="center" sx={{ mb: 2, fontSize: Fonts.GeneralLargeBodyFont.fontSize }}>
          To access your membership renewal page, please enter the code sent to
          your email: <br />
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Skeleton
                variant="text"
                sx={{ fontSize: Fonts.GeneralSmallBodyFont.fontSize, width: 200, height: 50 }}
              />
            </Box>
          ) : (
            <Box sx={{ fontWeight: FontWeights.SemiBold }}>{email}</Box>
          )}
        </Typography>

        <Formik
          initialValues={{ otp: ["", "", "", "", "", ""] }}
          validationSchema={OtpSchema}
          onSubmit={async (values) => {
            const otpValue = values.otp.join("");

            const body = {
              code: otpValue,
              token: otpToken,
            };
            setIsLoading(true);
            try {
              const res = await FormService.verifyCode(tempToken?.token, body);
              setVerifyModal(false);
              onHandleSubmit(res?.result);
            } catch (error) {
              setErrorMessage(error?.data?.message);
              setTimeout(() => {
                setErrorMessage(null);
              }, 7000);
            } finally {
              setIsLoading(false);
            }
          }}
        >
          {({ values, errors, touched, setFieldValue, isSubmitting }) => (
            <Form>
              <Box
                display="flex"
                justifyContent="center"
                sx={{
                  gap: {
                    xs: 0.5,
                    sm: 1,
                    md: 1.5,
                  },
                }}
                mb={2}
              >
                {values?.otp?.map((val, index) => (
                  <Field key={index} name={`otp[${index}]`}>
                    {() => (
                      <TextField
                        inputRef={(el) => (inputRefs.current[index] = el)}
                        value={val}
                        onChange={(e) => handleChange(e, index, setFieldValue)}
                        onKeyDown={(e) =>
                          handleKeyDown(e, index, values, setFieldValue)
                        }
                        onPaste={(e) => {
                          e.preventDefault();
                          const pasted = e.clipboardData
                            .getData("text")
                            .replace(/\D/g, ""); // digits only
                          if (!pasted) return;

                          const otpArray = [...values.otp];
                          for (
                            let i = 0;
                            i < pasted.length && index + i < 6;
                            i++
                          ) {
                            otpArray[index + i] = pasted[i];
                          }
                          otpArray.forEach((digit, i) =>
                            setFieldValue(`otp[${i}]`, digit)
                          );
                          // focus the last filled box
                          const lastIndex = Math.min(
                            index + pasted.length - 1,
                            5
                          );
                          inputRefs.current[lastIndex]?.focus();
                        }}
                        inputProps={{
                          maxLength: 1,
                          style: {
                            textAlign: "center",
                            fontSize: Fonts.GeneralHeaderFont.fontSize,
                            fontWeight: Fonts.GeneralHeaderFont.fontWeight,
                            width: "45px",
                          },
                        }}
                        variant="outlined"
                        error={
                          touched.otp &&
                          Boolean(errors.otp) &&
                          values.otp[index] === ""
                        }
                      />
                    )}
                  </Field>
                ))}
              </Box>
              {((touched.otp && errors.otp) || errorMessage) && (
                <Typography
                  color="error"
                  variant="caption"
                  align="center"
                  display="block"
                  sx={{ fontSize: Fonts.GeneralLargeBodyFont.fontSize }}
                >
                  {errorMessage ? errorMessage : "OTP Required"}
                </Typography>
              )}

              <DialogActions sx={{ flexDirection: "column", mt: 2, gap: 1 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{
                    borderRadius: 2,
                    px: 4,
                    textTransform: "none",
                    fontWeight: Fonts.GeneralSubHeaderFont.fontWeight,
                    backgroundColor: "#1675e0",
                    width: "100%",
                    fontSize: Fonts.GeneralSubHeaderFont.fontSize,
                  }}
                  disabled={isSubmitting}
                >
                  Verify
                </Button>

                <Button
                  variant="text"
                  disabled={coolDown > 0 || loading || isSubmitting}
                  onClick={handleResend}
                  sx={{ textTransform: "none", fontSize: Fonts.GeneralButtonFont.fontSize }}
                >
                  {coolDown > 0 ? `Resend code in ${coolDown}s` : "Resend Code"}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
};

export default OtpModal;
